interface SignatureBlockProps {
  /** Rótulos de los campos a completar a mano, en orden. */
  fields: string[]
}

/**
 * Consent block: one row of blank fields to fill in once printed. Each reserves
 * the writing height and closes with a bottom border, not repeated characters.
 */
export const SignatureBlock = ({ fields }: SignatureBlockProps) => (
  <div className='flex break-inside-avoid gap-6 pt-2'>
    {fields.map((field) => (
      // `flex-1` splits the width evenly, whatever the number of fields.
      <div key={field} className='min-w-0 flex-1'>
        <div className='h-[20mm] border-b border-b-2 border-zinc-400' />

        <p className='mt-2 text-center text-[8pt] uppercase leading-tight font-medium'>
          {field}
        </p>
      </div>
    ))}
  </div>
)
